import { render, staticRenderFns } from "./AddressDropdown.vue?vue&type=template&id=3bb11d88&scoped=true&"
import script from "./AddressDropdown.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./AddressDropdown.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./AddressDropdown.vue?vue&type=style&index=0&id=3bb11d88&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb11d88",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GuidanceBadge: require('C:/inetpub/wwwroot/bike-flights/components/guidance/GuidanceBadge.vue').default})
